import type { OpportunityStatus, SingleAvailableOpportunity } from '@ps/web-sports-api-types';

import {
  type Entity,
  sportsCompetition,
  sportsEvent,
  sportsMarket,
  sportsRace,
  sportsSelection,
  sportsSport
} from '../entities';

import { getIsOddsBoostMarket } from './utils/getIsOddsBoostMarket';
import { getRunnerStatus } from './utils/getRunnerStatus';

export const createSingleEntities = (bettableOpportunities: SingleAvailableOpportunity[]) =>
  bettableOpportunities.flatMap((single) => {
    const selectionEntity = sportsSelection({
      selectionId: single.runnerId.selectionId,
      selectionOdds: single.winRunnerOdds?.decimalDisplayOdds?.decimalOdds,
      selectionStatus: getRunnerStatus(single.status as OpportunityStatus),
      isStartingPrice: !single.winRunnerOdds
    });
    const marketEntity = sportsMarket({
      marketId: single.runnerId.marketId,
      marketInPlay: false,
      marketIsOddsBoost: getIsOddsBoostMarket(single.marketType)
    });
    const eventEntity = sportsEvent({
      eventId: Number(single.eventId),
      eventStartTime: new Date(single.eventStartTime).getTime()
    });
    const sportEntity = sportsSport({ sportId: Number(single.eventTypeId) });

    const entities: Entity[] = [selectionEntity, marketEntity, eventEntity, sportEntity];

    if (single.competitionId) {
      const competitionEntity = sportsCompetition({ competitionId: single.competitionId });
      entities.push(competitionEntity);
    }

    if (single.raceId) {
      const raceIdEntity = sportsRace({ raceId: single.raceId });
      entities.push(raceIdEntity);
    }

    return entities;
  });
